var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouRevendedorAllied(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2567_717)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 124.773,
    cy: 125,
    r: 125,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.245 84.3181C152.319 82.402 149.764 81.2481 147.053 81.0695C144.342 80.8909 141.658 81.6999 139.497 83.3468C137.336 84.9937 135.845 87.3672 135.298 90.0286C134.752 92.6899 135.187 95.4592 136.524 97.8244C137.889 96.9518 141.055 94.422 140.891 95.6404C140.709 96.8598 137.835 99.3168 137.835 99.3168C137.85 99.4375 137.856 99.5592 137.853 99.6808C138.845 100.817 140.057 101.743 141.415 102.401C142.773 103.059 144.25 103.437 145.757 103.513C147.264 103.588 148.772 103.359 150.189 102.839C151.605 102.319 152.903 101.52 154.004 100.488C155.105 99.4558 155.988 98.2126 156.598 96.8323C157.208 95.4521 157.535 93.9632 157.557 92.4541C157.58 90.9451 157.298 89.4471 156.729 88.0492C156.16 86.6515 155.315 85.3824 154.245 84.3181Z",
    fill: "#EFC38E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.603 140.168C127.238 138.917 125.721 137.842 124.09 136.965C114.846 131.922 105.315 127.424 95.5446 123.496C95.2687 122.476 95.0503 121.788 95.0503 121.788L84.6955 118.785C84.6955 118.785 72.5207 128.412 75.4873 137.038C77.1253 141.827 83.6035 148.23 105.46 153.252C103.225 164.619 100.364 175.855 96.8905 186.907C97.7382 185.071 102.584 183.983 108.317 184.626C114.486 185.318 119.291 187.556 119.072 189.649L119.144 189.74C120.509 177.258 120.976 164.693 120.541 152.144L139.262 179.816C138.208 178.326 141.023 174.043 145.642 170.142C150.335 166.174 155.105 164.118 156.306 165.519L156.379 165.555L128.603 140.168Z",
    fill: "#EFC38E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.048 133.326C198.636 132.651 198.032 132.113 197.315 131.781C196.597 131.448 195.798 131.336 195.016 131.459C194.235 131.582 193.507 131.933 192.926 132.469C192.344 133.005 191.934 133.701 191.748 134.47C191.563 135.238 191.61 136.044 191.882 136.787C192.155 137.529 192.641 138.175 193.28 138.64C193.919 139.106 194.682 139.372 195.472 139.404C196.262 139.436 197.044 139.233 197.719 138.821C198.167 138.548 198.558 138.189 198.868 137.766C199.178 137.341 199.4 136.86 199.524 136.349C199.647 135.838 199.669 135.309 199.587 134.791C199.506 134.271 199.322 133.774 199.048 133.326Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.108 155.563C165.52 156.239 166.123 156.776 166.841 157.108C167.558 157.441 168.358 157.553 169.14 157.43C169.92 157.308 170.648 156.956 171.23 156.421C171.811 155.884 172.221 155.188 172.407 154.42C172.593 153.651 172.546 152.845 172.274 152.103C172.001 151.36 171.514 150.715 170.875 150.249C170.236 149.783 169.474 149.517 168.684 149.486C167.893 149.453 167.112 149.656 166.436 150.068C165.988 150.341 165.597 150.7 165.288 151.125C164.977 151.548 164.755 152.03 164.632 152.54C164.508 153.051 164.486 153.581 164.568 154.099C164.65 154.618 164.834 155.115 165.108 155.563Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.204 69.0858C190.519 69.3875 190.916 69.5889 191.345 69.6648C191.775 69.7405 192.217 69.6873 192.616 69.5117C193.015 69.3361 193.353 69.0461 193.587 68.6782C193.821 68.3105 193.941 67.8816 193.931 67.4456C193.922 67.0098 193.783 66.5867 193.532 66.2298C193.282 65.8729 192.931 65.5983 192.524 65.4408C192.118 65.2833 191.674 65.2499 191.248 65.345C190.823 65.44 190.435 65.6591 190.134 65.9746C189.733 66.3975 189.515 66.9618 189.528 67.5446C189.541 68.1275 189.785 68.6814 190.204 69.0858Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7554 71.197C55.5746 71.4796 55.4785 71.808 55.4785 72.1434C55.4785 72.4789 55.5746 72.8073 55.7554 73.0898C55.9285 73.293 56.1477 73.4518 56.3946 73.5532C56.6416 73.6544 56.9091 73.6953 57.175 73.6722L55.7554 71.197Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2906 67.0118C64.1347 66.7748 63.9095 66.5918 63.6456 66.4876C63.3818 66.3833 63.0922 66.363 62.8164 66.4294C63.3078 67.212 63.781 68.0128 64.2906 68.7945C64.44 68.5212 64.5183 68.2146 64.5183 67.9031C64.5183 67.5916 64.44 67.2851 64.2906 67.0118Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.41 165.536C155.609 164.59 153.207 165.19 150.295 166.883L154.281 171.05C156.283 168.594 157.175 166.464 156.41 165.536Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.18 173.616C139.741 176.4 138.558 178.894 139.414 179.913C140.287 180.949 143.071 180.131 146.329 178.057L142.18 173.616Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.615 77.9845C101.012 77.3857 100.22 77.0149 99.3737 76.9353C98.5274 76.8556 97.6798 77.072 96.9754 77.5477C95.6322 77.2461 94.229 77.3604 92.9523 77.8753C92.5444 77.1932 91.9666 76.6285 91.2755 76.2363C90.5842 75.844 89.8032 75.6376 89.0084 75.6372C88.2136 75.6368 87.4324 75.8425 86.7408 76.2341C86.0492 76.6256 85.4709 77.1898 85.0623 77.8715C84.6537 78.5531 84.4288 79.3291 84.4096 80.1236C84.3903 80.9182 84.5773 81.704 84.9523 82.4048C85.3273 83.1055 85.8776 83.697 86.5494 84.1217C87.2212 84.5463 87.9916 84.7896 88.7854 84.8277C88.9481 86.3692 89.6353 87.8081 90.7319 88.9036C90.7319 88.9036 94.1899 93.0896 92.0241 95.1998C92.7506 94.6322 93.3416 93.9097 93.754 93.0851C94.1665 92.2604 94.39 91.3542 94.4082 90.4324C94.4248 90.2515 94.3935 90.0694 94.3172 89.9046C92.0978 87.3757 94.3537 85.3191 95.3365 87.0836C95.8097 87.939 96.119 87.939 96.3374 87.484C97.1746 85.2281 100.997 82.1523 101.924 86.1745V86.1563C102.071 86.9235 102.138 87.7039 102.124 88.485C102.124 88.0309 102.142 86.6113 102.142 85.2645C102.291 84.3886 102.267 83.4919 102.069 82.6255C102.547 81.9204 102.763 81.0706 102.68 80.2231C102.597 79.3756 102.221 78.5837 101.615 77.9845Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.141 189.704C119.306 188.284 117.139 186.81 113.826 185.776L113.135 192.364C116.575 192.088 118.978 191.105 119.141 189.704Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7932 187.21C96.6294 188.685 98.9963 190.25 102.58 191.269L103.346 184.5C99.6324 184.735 96.9752 185.736 96.7932 187.21Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.001 179.112C160.044 180.771 154.85 181.613 149.623 181.603L151.989 184.15C158.893 186.593 166.317 187.177 173.518 185.842C170.901 183.331 168.049 181.077 165.001 179.112Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.897 206.045C109.594 202.871 105.651 199.234 102.141 195.199L101.719 198.854C102.811 201.893 105.049 208.189 113.475 216C114.407 213.343 114.28 209.594 113.897 206.045Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.469 107.72C100.263 109.129 99.957 110.522 99.5547 111.888C100.288 112.432 101.062 112.919 101.87 113.344C101.433 111.47 100.942 109.249 100.469 107.72Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8633 93.7812C96.2091 94.6912 96.5338 95.6367 96.8461 96.7297C96.8087 96.0581 96.9736 95.3908 97.3193 94.8139C96.7667 94.5759 96.2706 94.2241 95.8633 93.7812Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.492 153.27L103.271 164.099L107.53 153.726L105.492 153.27Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6699 101.627L82.2332 107.318L83.67 104.007C83.67 104.007 80.8376 101.757 80.6699 101.627Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.869 61.7521L112.824 59.4043L116.228 46.3204L121.541 44.4458L125.272 48.6854L121.869 61.7521Z",
    fill: "#2480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.564 54.8554C164.69 55.3306 164.672 55.8325 164.513 56.2977C164.354 56.7628 164.06 57.1704 163.669 57.4687C163.278 57.767 162.808 57.9427 162.318 57.9736C161.827 58.0044 161.338 57.8891 160.912 57.6422C160.488 57.3952 160.145 57.0278 159.929 56.5863C159.713 56.1447 159.633 55.649 159.698 55.1617C159.763 54.6744 159.972 54.2175 160.296 53.8487C160.622 53.4799 161.049 53.2159 161.524 53.09C162.161 52.9224 162.839 53.0141 163.409 53.345C163.979 53.6759 164.393 54.2189 164.564 54.8554Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.37 59.3132C172.497 59.7884 172.48 60.2903 172.32 60.7556C172.161 61.2208 171.868 61.6285 171.477 61.9269C171.086 62.2254 170.616 62.4012 170.125 62.4323C169.634 62.4633 169.145 62.3481 168.72 62.1012C168.295 61.8544 167.953 61.4869 167.736 61.0454C167.52 60.6039 167.439 60.1081 167.504 59.6208C167.57 59.1335 167.778 58.6766 168.103 58.3077C168.429 57.9389 168.856 57.6747 169.331 57.5487C169.968 57.3812 170.645 57.4728 171.215 57.8034C171.784 58.1341 172.2 58.6769 172.37 59.3132Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.018 64.6095L170.097 50.7239",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.05 133.326C198.638 132.651 198.034 132.113 197.317 131.781C196.599 131.449 195.799 131.337 195.018 131.459C194.237 131.582 193.509 131.933 192.928 132.469C192.346 133.005 191.936 133.702 191.75 134.47C191.565 135.238 191.612 136.045 191.884 136.787C192.157 137.529 192.643 138.175 193.282 138.641C193.921 139.106 194.684 139.372 195.474 139.404C196.264 139.437 197.046 139.233 197.721 138.822C198.169 138.549 198.56 138.189 198.87 137.766C199.18 137.342 199.402 136.86 199.526 136.349C199.649 135.839 199.671 135.309 199.589 134.791C199.507 134.272 199.324 133.774 199.05 133.326Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.11 155.564C165.522 156.239 166.125 156.776 166.843 157.109C167.56 157.441 168.36 157.553 169.141 157.431C169.922 157.308 170.65 156.956 171.232 156.421C171.813 155.885 172.223 155.188 172.409 154.42C172.595 153.652 172.548 152.845 172.276 152.103C172.003 151.36 171.516 150.715 170.877 150.249C170.238 149.784 169.476 149.517 168.686 149.486C167.895 149.453 167.114 149.656 166.438 150.068C165.99 150.341 165.599 150.7 165.29 151.125C164.979 151.548 164.757 152.03 164.634 152.541C164.51 153.051 164.488 153.581 164.57 154.099C164.652 154.618 164.836 155.115 165.11 155.564Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.299 137.748L172.062 151.633",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.047 131.47L183.637 74.7643L191.735 67.5034",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.881 120.66L152.772 142.553L131.279 123.244L186.33 88.1758L192.881 120.66Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.204 69.0858C190.519 69.3875 190.916 69.5889 191.345 69.6648C191.775 69.7405 192.217 69.6873 192.616 69.5117C193.015 69.3361 193.353 69.0461 193.587 68.6782C193.821 68.3105 193.941 67.8816 193.931 67.4456C193.922 67.0098 193.783 66.5867 193.532 66.2298C193.282 65.8729 192.931 65.5983 192.524 65.4408C192.118 65.2833 191.674 65.2499 191.248 65.345C190.823 65.44 190.435 65.6591 190.134 65.9746C189.733 66.3975 189.515 66.9618 189.528 67.5446C189.541 68.1275 189.785 68.6814 190.204 69.0858Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.098 108.428C132.481 108.302 139.09 106.106 142.71 102.952",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.778 103.536C140.746 103.001 140.668 102.471 140.545 101.95",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85 99.677C138.014 99.8772 138.19 100.06 138.378 100.259C140.397 102.271 143.104 103.441 145.953 103.533C148.801 103.625 151.578 102.633 153.724 100.757C155.869 98.8802 157.222 96.2596 157.51 93.4242C157.798 90.5887 156.999 87.7497 155.274 85.4806C153.55 83.2116 151.028 81.6816 148.219 81.1998C145.41 80.718 142.522 81.3203 140.141 82.8849C137.759 84.4496 136.058 86.86 135.385 89.6293C134.712 92.3986 135.114 95.3203 136.512 97.8043",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2534 107.448L83.6548 104.027L80.6719 101.629",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8528 96.8119L95.8125 93.7466C96.2983 94.1326 96.8169 94.4756 97.3624 94.7715",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9961 100.15C95.8839 100.096 92.6443 97.8207 89.8789 95.2737",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.861 95.2737L89.2422 99.8773L94.8832 99.4041L98.6142 103.499L98.9964 100.15",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.817 66.4296C63.0928 66.3657 63.3815 66.3871 63.6448 66.4912C63.9082 66.5952 64.1336 66.7768 64.2912 67.012C65.0777 68.1011 63.7816 70.3416 61.4348 72.016C59.0879 73.6904 56.5399 74.1627 55.7746 73.0697C55.594 72.787 55.498 72.4587 55.498 72.1233C55.498 71.7878 55.594 71.4595 55.7746 71.1769",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.499 103.754C135.463 103.099 138.066 101.242 137.829 99.2949C137.829 99.2949 140.703 96.8379 140.886 95.6195C141.069 94.401 137.829 96.9653 136.48 97.8226C134.213 99.2794 131.855 100.587 129.418 101.736",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 107.72L101.871 113.344",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.127 88.485C102.127 88.03 102.145 86.6113 102.145 85.2645C102.294 84.3886 102.269 83.4919 102.072 82.6255C102.546 81.9197 102.76 81.071 102.677 80.225C102.593 79.379 102.219 78.5881 101.616 77.9881C101.014 77.388 100.222 77.016 99.3757 76.9358C98.5294 76.8558 97.6815 77.0723 96.9774 77.5487C95.6342 77.2462 94.2307 77.3605 92.9542 77.8763C92.5463 77.1942 91.9685 76.6295 91.2774 76.2373C90.5862 75.845 89.8051 75.6386 89.0104 75.6382C88.2156 75.6378 87.4343 75.8435 86.7427 76.235C86.0511 76.6265 85.4729 77.1907 85.0642 77.8724C84.6557 78.5541 84.4308 79.33 84.4115 80.1246C84.3923 80.9191 84.5792 81.705 84.9542 82.4057C85.3293 83.1064 85.8796 83.698 86.5513 84.1226C87.2231 84.5473 87.9936 84.7905 88.7874 84.8287C88.9499 86.3702 89.637 87.8091 90.7338 88.9045C90.7338 88.9045 94.347 93.2783 91.8737 95.3387",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.328 178.057C143.071 180.132 140.271 180.947 139.394 179.913C137.67 177.878 143.458 172.058 145.8 170.081C148.004 168.222 154.7 163.508 156.41 165.536C157.176 166.445 156.283 168.612 154.281 171.069",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.001 179.112C160.044 180.772 154.85 181.613 149.623 181.603",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.296 166.901L154.937 171.742C156.826 173.91 159.072 175.738 161.579 177.147C165.958 179.464 169.983 182.393 173.535 185.845C166.335 187.18 158.91 186.596 152.007 184.153L142.18 173.616",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.136 192.36C116.576 192.088 118.988 191.104 119.142 189.704C119.447 186.913 112.267 185.187 109.15 184.77C105.4 184.268 97.1236 184.241 96.7932 187.21C96.6294 188.685 98.9963 190.25 102.58 191.269",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.145 195.199C105.641 199.247 109.585 202.885 113.901 206.045",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.359 184.552L101.721 198.839C102.813 201.878 105.051 208.175 113.477 215.986C114.827 212.071 113.916 205.655 113.277 201.555C112.829 198.726 112.755 195.85 113.058 193.001C113.141 192.242 113.011 193.508 113.82 185.801",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 165.463L107.493 153.672L105.438 153.214",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8988 186.823C100.405 175.798 103.257 164.575 105.439 153.214C83.5812 148.198 77.1087 141.769 75.4841 137.001C72.5146 128.38 84.6923 118.749 84.6923 118.749",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9727 127.993C102.227 132.504 110.028 137.8 117.267 143.808C118.223 144.577 119.005 145.542 119.56 146.637C120.116 147.732 120.432 148.933 120.487 150.159C121.042 163.355 120.598 176.575 119.16 189.704",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0469 121.752C95.8461 124.262 96.3828 126.847 96.6485 129.468",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.202 179.607L120.561 152.052",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5195 123.444C105.299 127.389 114.845 131.891 124.109 136.929C125.743 137.8 127.26 138.877 128.622 140.132L156.21 165.342",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2727 68.7945C64.2727 68.7945 59.7965 62.7895 60.5609 58.3851C61.3435 53.8724 60.4402 53.7872 58.4679 57.8582C57.1623 60.5538 56.7207 66.8481 56.7207 66.8481",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.179 73.6722C57.179 73.6722 53.1693 66.7964 50.9738 62.0817C49.331 58.5538 51.447 59.9523 52.0476 61.1353",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2278 58.367C54.9546 57.0497 54.8084 55.7092 54.791 54.364C54.791 50.3236 55.7786 50.5228 56.6474 53.9454C57.0527 55.5539 57.5449 57.1393 58.1216 58.6946",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9749 57.6763C54.37 59.4385 53.4191 61.6985 53.2812 64.0779",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9391 56.4751C54.5751 55.6379 54.2121 54.6551 53.8653 53.6014C52.6478 49.8886 51.8825 50.7076 52.2829 54.0928C52.5713 56.4525 53.1454 58.7685 53.9927 60.9896",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6614 56.5478C51.4065 52.4892 50.4735 53.2182 50.9879 56.931C51.3818 59.4122 52.1549 61.8182 53.2802 64.0644",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.813 160.187L74.2832 169.995",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4514 166.373L70.6426 163.825",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.873 61.7521L112.828 59.4043L116.232 46.3204L121.545 44.4458L125.276 48.6854L121.873 61.7521Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.708 48.1221C121.654 48.3273 121.541 48.5119 121.382 48.6526C121.223 48.7933 121.026 48.8837 120.816 48.9126C120.606 48.9414 120.392 48.9072 120.201 48.8145C120.011 48.7217 119.851 48.5744 119.744 48.3913C119.637 48.2081 119.587 47.9974 119.6 47.7856C119.612 47.5738 119.687 47.3706 119.816 47.2016C119.944 47.0325 120.119 46.9052 120.32 46.8359C120.52 46.7665 120.737 46.7581 120.942 46.8117C121.214 46.8889 121.446 47.0685 121.589 47.3128C121.732 47.557 121.774 47.847 121.708 48.1221Z",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.844 46.7879C126.742 43.3471 119.546 37.4379 125.478 34",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.605 88.2485L144.02 96.3102",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.349 94.5819L142.287 89.9773",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6758 72.9326C60.3532 82.2539 69.6994 92.6441 80.6768 101.629C82.3206 107.26 83.6635 112.975 84.7 118.749L95.0548 121.752C96.7948 118.576 98.3016 115.279 99.5636 111.885C102.342 113.771 105.369 115.259 108.558 116.307C110.129 116.87 111.84 116.908 113.435 116.416C119.865 114.462 126.142 112.035 132.215 109.155C131.885 106.241 130.765 103.473 128.977 101.148C123.534 103.649 117.809 105.482 111.926 106.608C107.014 104.85 102.346 102.471 98.0368 99.5295C96.5041 98.5208 96.6612 96.3435 97.3662 94.7678C99.192 95.6615 101.997 95.8368 102.131 88.6104C102.274 81.3304 97.5243 84.7223 96.4131 87.3096C96.1583 87.9045 95.8968 88.0759 95.3432 87.0816C94.3632 85.3153 92.0863 87.369 94.324 89.9026C94.4152 90.1968 94.4401 90.5076 94.3968 90.8126C93.6458 94.7678 91.6486 97.039 88.4645 94.3569C79.218 86.5874 71.9217 79.5976 64.2968 67.0051",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5547 111.888C100.281 110.025 100.587 108.024 100.45 106.028",
    stroke: "#033B71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2567_717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouRevendedorAllied);
export default __webpack_public_path__ + "static/media/SouRevendedorAllied.ee09de7de8a50338603d3c69ff14c34c.svg";
export { ForwardRef as ReactComponent };